"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const publisher_form_type_1 = require("@App/enum/publisher-form-type");
require("./index.scss");
const CreatePublisherDetails_1 = __importDefault(require("@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherCreateForm/CreatePublisherDetails"));
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("@hookform/resolvers/zod");
const add_publisher_schema_1 = require("@Entities/schemas/wizardFlow/add-publisher-schema");
const SubmitButton_1 = __importDefault(require("@Fields/SubmitButton"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const IsNonRepresentativePopup_1 = __importDefault(require("@Components/Popups/IsNonRepresentativePopup"));
const RepresentativeDetails_1 = __importDefault(require("@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherCreateForm/RepresentativeDetails"));
const publisher_side_bar_state_1 = require("@App/enum/publisher-side-bar-state");
const PublisherCreateForm = (props) => {
    const { publisherStepStore, publisherSearchStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { publisherData, topClass, isAdministrator, setPublisherData, addPublisherToDraft } = props;
    const [step, setStep] = (0, react_1.useState)(0);
    const [isRepresentative, setIsRepresentative] = (0, react_1.useState)(true);
    const [isNonRepresentativePopupOpen, setIsNonRepresentativePopupOpen] = (0, react_1.useState)(false);
    const publisherLabel = isAdministrator ? 'Administrator' : 'Publisher';
    // if creating an Admin publisher, then admin publisher data is required
    if (isAdministrator && !publisherData) {
        throw new Error('No Administrator Publisher Data');
    }
    // if creating a nonAdmin then ogPublisherData is required
    if (!isAdministrator && !publisherData) {
        throw new Error('No Original Publisher Data');
    }
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        resolver: (0, zod_1.zodResolver)(add_publisher_schema_1.addPublisherSchema),
    });
    const setRepresentation = (id) => {
        setIsRepresentative(id === 1);
    };
    const closeNonRepresentativePopup = () => {
        setIsNonRepresentativePopupOpen(false);
        popupStore.setPublisherSidebarState(publisher_side_bar_state_1.PublisherSideBarState.empty);
    };
    const checkCreatingPublisher = (data) => __awaiter(void 0, void 0, void 0, function* () {
        if (step === 0 && !isAdministrator) {
            setStep(1);
            return;
        }
        const formData = Object.assign(Object.assign({}, publisherData), { publisherName: data.publisherName.trim(), ipiNumber: data.ipiNumber.trim() });
        if (!isRepresentative && !isAdministrator) {
            setIsNonRepresentativePopupOpen(true);
        }
        else {
            if (formData) {
                setPublisherData(formData);
            }
            const searchObj = {
                publisherName: formData === null || formData === void 0 ? void 0 : formData.publisherName,
                publisherIpi: formData === null || formData === void 0 ? void 0 : formData.ipiNumber,
            };
            publisherSearchStore.setPublisherSearch(searchObj);
            yield publisherSearchStore.searchPublishers(true);
            const searchResult = publisherSearchStore.publisherSearchModel;
            if (searchResult && searchResult.results.length) {
                publisherStepStore.setFormType(publisher_form_type_1.PublisherFormType.afterFind);
                return;
            }
            addPublisherToDraft();
        }
    });
    (0, react_1.useEffect)(() => {
        var _a;
        methods.reset({
            publisherName: publisherData.publisherName,
            ipiNumber: (_a = publisherData.ipiNumber) !== null && _a !== void 0 ? _a : undefined,
        });
    }, []);
    const { publisherName, ipiNumber } = isAdministrator ? add_publisher_schema_1.addAdministratorFormFields : add_publisher_schema_1.addPublisherFormFields;
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: isNonRepresentativePopupOpen },
            react_1.default.createElement(IsNonRepresentativePopup_1.default, { onClose: () => closeNonRepresentativePopup() })),
        react_1.default.createElement("form", { onSubmit: methods.handleSubmit(checkCreatingPublisher) },
            react_1.default.createElement("div", { className: topClass },
                react_1.default.createElement("h2", null,
                    "Create ",
                    publisherLabel),
                step === 0 && (react_1.default.createElement(CreatePublisherDetails_1.default, { publisherName: publisherName, ipiNumber: ipiNumber, isAdministrator: isAdministrator })),
                !isAdministrator && step === 1 && react_1.default.createElement(RepresentativeDetails_1.default, { setRepresentation: setRepresentation }),
                react_1.default.createElement("div", { className: 'create-publisher-button-container' },
                    react_1.default.createElement(SubmitButton_1.default, { label: `Create ${publisherLabel}`, disabled: !methods.formState.isValid }))))));
};
exports.default = PublisherCreateForm;
